import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { resetEntityState } from '../Common/Entity/actions/reduxActions';

const BottomTabBar = ({ tabConfig }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentPath = location.pathname;

  const handleTabChange = (event, newValue) => {
    dispatch(resetEntityState());
    navigate(newValue);
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 999,
        border: 'none',
        boxShadow:"none",

      }}
    >
      <BottomNavigation
        value={currentPath}
        onChange={handleTabChange}
        sx={{ 
            height: 70,
            borderRadius: '16px', 
            border: 'none',
            boxShadow: '0px 2px 8px 0px #0000001A',
            p: 0,
            alignItems: 'center',
            justifyContent: 'center',
        }}
      >
        {tabConfig.map((tab) => {
            const isSelected = currentPath === tab.route;
            return (
                <BottomNavigationAction
                    key={tab.key}
                    label={tab.label}
                    value={tab.path}
                    icon={isSelected ? tab.activeIcon : tab.inactiveIcon}
                    showLabel
                    sx={{
                      padding: 0,
                      alignContent: 'center',
                      minWidth: 'unset',
                      ".MuiBottomNavigationAction-label": {
                        fontSize: "11px",
                        transition: "none",
                        lineHeight: "20px",
                        fontWeight: 600,
                        color: isSelected ? "#995A00" : "#666666",
                      },
                      "&.Mui-selected": {
                        ".MuiBottomNavigationAction-label": {
                          color: "#995A00",
                          fontSize: "11px",
                          fontWeight: 600,
                        },
                        ".MuiSvgIcon-root": {
                          color: "#995A00",
                        },
                      },
                    }}
                />
            );
        })}
      </BottomNavigation>
    </Paper>
  );
};

export default BottomTabBar;
